import { render, staticRenderFns } from "./HeroColorField.vue?vue&type=template&id=5835f0c4&scoped=true&"
import script from "./HeroColorField.vue?vue&type=script&lang=js&"
export * from "./HeroColorField.vue?vue&type=script&lang=js&"
import style0 from "./HeroColorField.vue?vue&type=style&index=0&id=5835f0c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5835f0c4",
  null
  
)

export default component.exports